import {Component, Fragment, h} from "preact";
import {Link} from "react-router-dom";
import {t} from "../_i18n";

export const TabsCompany = ({match}: any)=> {

    return <div className="tabs-container">
        <div className="inline">
            <Link to={'/company/preview'} className={match.path.endsWith(`preview`)?'selected':''}>{t('Información')}</Link>
        </div>
        <div className="inline">
            <Link to={'/company/preview/offers'} className={match.path.includes('offers')?'selected':''}>{t('Ofertas')}</Link>
        </div>
    </div>;
}
